import React, { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";
import { useLang, LANG_OPTIONS } from "@/lib/lang";
import "./LangDropdown.css";

/**
 * Compact language selector dropdown — dark-theme friendly.
 * Used in the landing header and Client Portal shell.
 */
export default function LangDropdown({ testId = "lang-dropdown" }) {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div className="lang-dd" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="lang-dd__trigger"
        data-testid={`${testId}-btn`}
        aria-label="Escolher idioma"
      >
        <Globe size={13} /> {lang}
      </button>
      {open && (
        <div className="lang-dd__panel" data-testid={`${testId}-menu`}>
          {LANG_OPTIONS.map((o) => (
            <button
              key={o.code}
              type="button"
              onClick={() => { setLang(o.code); setOpen(false); }}
              className={`lang-dd__item ${o.code === lang ? "is-active" : ""}`}
              data-testid={`${testId}-${o.code}`}
            >
              <span className="lang-dd__code">{o.code}</span>
              <span className="lang-dd__label">{o.label.split(" · ")[1] || o.label}</span>
              {o.code === lang && <Check size={12} className="lang-dd__check" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
